module.exports = __webpack_public_path__ + "img/balance_bg.8bff8db1.png";